// import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
// import { RouterModule, Routes } from '@angular/router';

import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CoreService, CustomerUser } from '../services/core.service';
import { TournamentsService } from '../tournaments/services/tournaments.service';

import { translatePipe, translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { environment } from '../../../../environments/version';
import { ElectronService } from 'ngx-electron';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AppComponentBase } from '../../../shared/app-component-base';

declare let $;
declare let SetLanguage: any;
declare let langCode;

declare let _sendChromeMessage: any;
const IDLE_WAIT = 3;

@Component({
    selector: 'comp_allscreen',
    templateUrl: './allscreen.html',
})
export class AllScreen extends AppComponentBase implements OnInit {
    public today: number = Date.now();
    public clickCounter = 0;
    public changePage = 1;
    public myDate: Date;
    public SelectedLanguage_LangCode = 'en';
    public fixtureType = 0;
    public Balance_Text_IsActive = 1;
    public flag_initialmoney = 0;
    public versionT = environment.version;
    public init: boolean;

    lastPing?: Date = null;

    liveGoalListData = [];

    constructor(
        private route: ActivatedRoute,
        public coreService: CoreService,
        public tournamentsService: TournamentsService,
        public _uiHelper: uiHelper,
        public translate: translationHelper,
        private _ElectronService: ElectronService,
        private idle: Idle,
        private keepalive: Keepalive,
        private _injector: Injector,
    ) {
        super(_injector);
        this.SelectedLanguage_LangCode = langCode;
        this.coreService.customerUser = this.getNewCustomerUser();

        this.warningIdleStart();

        this._uiHelper.liveGoalListListener.subscribe((x: any) => {
            this.liveGoalListData = x;
            // console.log('liveGoalListData', x);
            if (x && x != []) {
                this.RunLiveGoalSlide();
            }
        });
    }

    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
        this.fixtureType = 0;
        setInterval(() => {
            this.today = Date.now();
        }, 1000);
        // this.route.params.subscribe(params => {
        //    this.btnLive(params['id']);
        this.route.params.subscribe(params => {
            this.changeFixture(params['id']);
        });

        // this.coreService.customerUser = this.getNewCustomerUser();
        this.tournamentsService.getTaxRate();
        this.getCustomerUser();

        $('body #Login_Modal').remove();
        $('.ui.active.dimmer').dimmer('hide');
        $('.dimmed.dimmable >.ui.animating.dimmer').dimmer('hide');
        $('.dimmed.dimmable>.ui.visible.dimmer').dimmer('hide');
        SetLanguage('', '');
        // this.tournamentsService.getAllUpcoming();
        this.GetTerminalInfo();
        this.GetTermialActiveStatus();

        // Müşteri kartı takılırsa 3 dk lık hareketsizlik durumun durdur. Çıkarınca tekrar aktif et.
        this._uiHelper.customerCardStatusListener.subscribe((x: boolean) => {
            if (x) {
                this.idle.stop();
               this. warningIdleStart() 
            } else {
                this.idle.watch();
            }
        });
    }

    // IDLE - Hareketsiz kalınca Refresh

    warningIdleStart() {
        // sets an idle timeout of 5 seconds, for testing purposes.
        this.idle.setIdle(10);
        this.idle.setTimeout(IDLE_WAIT * 60);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onIdleEnd.subscribe(() => console.warn('--onIdleEnd--'));
        this.idle.onTimeout.subscribe(() => {
            this.ExitQrCustomer();
            // her türlü resetlenmesi gerekiyor.
            this.resetWarningIdle();
        });

        this.idle.onInterrupt.subscribe(() => console.log('--onInterrupt--'));
        this.idle.onIdleStart.subscribe(() => {}); //console.log('--onIdleStart--')));
        // this.idle.onTimeoutWarning.subscribe(
        //   countdown =>
        //     (console.log("You will time out in " + countdown + " seconds!"))
        // );
        // sets the ping interval to 15 seconds
        this.keepalive.interval(15);

        this.keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

        this.resetWarningIdle();
    }

    resetWarningIdle() {
        this.idle.watch();
    }

    // IDLE - Hareketsiz kalınca Refresh

    RunLiveGoalSlide() {
        if (this.liveGoalListData && this.liveGoalListData != []) {
            for (let i = 0; i < this.liveGoalListData.length; i++) {
                setTimeout(() => {
                    if (i != 0) {
                        if (this.liveGoalListData[i - 1] != undefined) this.liveGoalListData[i - 1].visible = false;
                    }
                    if (this.liveGoalListData[i] != undefined) this.liveGoalListData[i].visible = true;
                }, i * 3000);
            }
        }
    }

    public changeFixture(e) {
        this.fixtureType = e;
    }

    public ChangePage() {}

    public SlipControlModal_Button_No() {
        $('#SlipControlModal').modal('hide');
    }

    public CardCustomerId_Button_No() {
        $('#CardCustomerId').modal('hide');
    }

    public btnCashOut() {}

    public Open_Language_Modal() {
        $('#Language_Modal').modal('show');
    }

    public Change_SelectedLanguage_LangCode(langCode) {
        this.SelectedLanguage_LangCode = langCode;
    }

    public CardSignOut() {
        this.coreService.SignOutCard();
    }

    public Open_Info_Modal() {
        $('#Info_Modal').modal('show');
    }

    public getCustomerUser() {
        this.coreService.configureClient();
    }

    public getNewCustomerUser(): CustomerUser {
        return {
            UserName: 'Test',
            Balance: '',
            IsLogged: false,
            Symbol: '',
            TerminalBalance: '',
            TerminalId: '',
            CustomerCardActiveControl: '',
            CustomerCardMessage: '',
            CurrentBalance: '0',
            IsAnonymousBet: 0,
            TerminalIsActive: 0,
            IsTerminal: 1,
            ParentBranchId: '',
            CustomerId: '',
        };
    }

    public getCurrentTime(e) {
        const _eventDate = new Date(e);
        _eventDate.setTime(_eventDate.getTime() + -1 * _eventDate.getTimezoneOffset() * 60 * 1000);

        return (
            (_eventDate.getHours() < 10 ? '0' + _eventDate.getHours() : _eventDate.getHours()) +
            ':' +
            (_eventDate.getMinutes() < 10 ? '0' + _eventDate.getMinutes() : _eventDate.getMinutes()) +
            ':' +
            (_eventDate.getSeconds() < 10 ? '0' + _eventDate.getSeconds() : _eventDate.getSeconds())
        );
    }

    public ResetButtonClick() {
        this.clickCounter = 0;
    }

    public getBalanceButtonBg() {
        // console.log("BAKİYE", this.coreService.customerUser.TerminalBalance);
        if (this.coreService.customerUser.TerminalBalance != '0.00') {
            return '#67b149';
        } else {
            return '#e0e1e2';
        }
    }

    public OpenPasswordModal() {
        setTimeout(() => (this.clickCounter = 0), 3000);

        this.clickCounter += 1;

        if (this.clickCounter == 3) {
            // $('#settingPassword_Modal')
            //    .modal({
            //        allowMultiple: true

            //    }).modal('show');
            // $('#Terminal_Keyboard_Modal')
            //    .modal({
            //        allowMultiple: true
            //    }).modal('show');

            $('#SettingPasswordModalLogin')
                .modal({
                    // allowMultiple: true,
                    detachable: false,
                })
                .modal('show');
            this.clickCounter = 0;
        }
    }

    public Open_Payout_Modal() {
        this.coreService.configureClient();
        if (this.coreService.customerUser.TerminalBalance != '0.00') {
            $('#PayoutModal')
                .modal({
                    detachable: false,
                })
                .modal('show');
        }
    }

    public Open_Transaction_Page() {
        this.tournamentsService.cleanOpenBets_Timer();
        this.tournamentsService.customerTransactionDate = '7' + ' ' + this.translate.getT('Day');

        // this.tournamentsService.getCustomerTransaction(-10, 7);
        this.tournamentsService.getCustomerBets('All', 7);
        this.tournamentsService.router.navigate(['/CustomerTransaction']);
    }

    public Change_Balance_Text_Status() {
        if (this.Balance_Text_IsActive == 0) {
            this.Balance_Text_IsActive = 1;
        } else {
            this.Balance_Text_IsActive = 0;
        }
    }

    public GetTerminalInfo() {
        this.tournamentsService.getTerminalInfo();

        if (this.flag_initialmoney == 0) {
            console.log('run money reader');
            this.flag_initialmoney = 1;

            setTimeout(() => {
                _sendChromeMessage({
                    command: 'runmoneyreader',
                });

                if (
                    this._uiHelper.terminalConfig.TemporaryBet == false ||
                    this._uiHelper.terminalConfig.IsBetOn == false
                ) {
                    this._uiHelper.SendElectronMessage('electronListener', {
                        type: 'moneyReader_control',
                        money_reader_status: 'disable',
                    });
                } else {
                    this._uiHelper.SendElectronMessage('electronListener', {
                        type: 'moneyReader_control',
                        money_reader_status: 'enable',
                    });
                }
            }, 5000);

            setTimeout(() => {
                if (
                    this._uiHelper.terminalConfig.TemporaryBet == false ||
                    this._uiHelper.terminalConfig.IsBetOn == false
                ) {
                    this._uiHelper.SendElectronMessage('electronListener', {
                        type: 'moneyReader_control',
                        money_reader_status: 'disable',
                    });
                } else {
                    this._uiHelper.SendElectronMessage('electronListener', {
                        type: 'moneyReader_control',
                        money_reader_status: 'enable',
                    });
                }
            }, 30000);

            // _sendChromeMessage("runmoneyreader");
        }
    }

    // Terminalin Aktifliğine göre Para Okuma Makinesi kapanıyor
    public GetTermialActiveStatus() {
        this.tournamentsService.getTermialActiveStatus().then(x => {
            // console.log('#####getTermialActiveStatus#####', x);
            if (x == 0) {
                // Geçici olarak kapatıldı. Sonra açılacak . 09.09.2021
                // setTimeout(() => {
                //     _sendChromeMessage({
                //         command: 'haltmoneyreader',
                //     });
                //     if (this._ElectronService.isElectronApp) {
                //         this._ElectronService.ipcRenderer.send('electronListener', {
                //             type: 'moneyReader_control',
                //             money_reader_status: 'disable',
                //         });
                //     }
                // }, 30000);
            }
        });
    }

    public handleSportChange(e) {
        this._uiHelper.setSportType(1);
        //this._uiHelper.resetOddType_LIVE();
        // this._uiHelper.resetOddType_PRE();
        this._uiHelper.setTypeOfList(e);
    }

    OpenQrModal() {
        let qr = '900' + this.tournamentsService.Terminal_ID.toString();
        this._uiHelper.SetQrCode(qr);
        $('#QR_Modal')
            .modal('setting', 'closable', false)
            .modal('show');
    }
    totalidlecounter = 0;
    ExitQrCustomer() {
        //console.log('IDLE-EXIT :' +new Date());
        this._uiHelper.SetCustomerQrStatus(false);
        window.postMessage({ command: 'cardinserted', message: 'removed' }, '*');

        // this._UiHelper.setRefreshApp();
        this.tournamentsService.clearSlip();

        // 30.09.2021 de Kapatıldı
        // LiveBets e Yönlendirme için Kapatıldı. Test edilmesi lazım
        // if (this.coreService.customerUser.IsLogged) {
        //     this.tournamentsService.router.navigate(['/LiveBets']);
        // }
        //this._uiHelper.SendElectronMessage('electronListener', {
        //    type: 'moneyReader_control',
        //    money_reader_status: 'disable',
        //});
        //location.reload();

        //3 DK sonra kimse dokunmazsa burası perfect çalışıyor.

        this.totalidlecounter++;
        if (this.totalidlecounter > 5) {
            this.totalidlecounter = 0;
            location.reload();
        }

        this.tournamentsService.router.navigate(['/LiveBets']);
        this._uiHelper.idleResetListener.emit();
    }
}
